import type { Recipient, RecipientSort } from '../types';

function compareValues(a: string, b: string): number {
  return a.localeCompare(b, 'pt-BR', { sensitivity: 'base' });
}

export function sortRecipients(recipients: Recipient[], sort: RecipientSort | null): Recipient[] {
  if (!sort) return recipients;

  const sorted = [...recipients].sort((left, right) => {
    if (sort.key === 'name') {
      return compareValues(left.name, right.name);
    }

    if (sort.key === 'whatsapp') {
      return compareValues(left.whatsapp ?? '', right.whatsapp ?? '');
    }

    if (sort.key === 'status') {
      return compareValues(left.status, right.status);
    }

    return Number(Boolean(left.alreadySent)) - Number(Boolean(right.alreadySent));
  });

  return sort.direction === 'desc' ? sorted.reverse() : sorted;
}

export function nextSort(
  current: RecipientSort | null,
  key: RecipientSort['key']
): RecipientSort | null {
  if (current?.key !== key) {
    return { key, direction: 'asc' };
  }

  if (current.direction === 'asc') {
    return { key, direction: 'desc' };
  }

  return null;
}
